import Select from 'react-bootstrap/FormSelect';

const Eins = (props) => {
    return (
        <Select className='text-center' onChange={e => { props.onSelectChange(e.target.value) } }>
            <option value="0">-</option>
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="50">50</option>
        </Select>
    )
}

export default Eins